import React, { useState } from 'react'
import { HelperText } from 'react-native-paper'
import { observer } from 'mobx-react'
import { InputText } from '@linqpal/common-frontend/src/ui'
import { ContainerCreditApplication } from './ContainerCreditApplication'
import { ButtonFlowNext } from '../molecules/ButtonFlowNext'
import { MaskedInputBase } from '../../screens/Contractor/CreditApplication/LoanApplication/MaskedInput'
import { KeyboardTypeOptions } from 'react-native'

interface InputSingleTextNextButtonProps {
  onValue: (arg1, arg2) => void
  currentData: any
  placeHolder: string
  inputMask?: string
  maskType?: string
  maskedInputProps?: any
  save?: boolean
  children?: React.ReactElement
  nativeProps: any
  errorText?: string
  personalValue?: string
  validate?: () => void
  identifier?: string
  textBeforeButton: React.ReactElement
  data?: string
  document: any
  required?: boolean
  keyboardType?: KeyboardTypeOptions
}

export const InputSingleTextNextButton = observer(
  ({
    onValue,
    currentData,
    placeHolder,
    inputMask,
    maskType,
    maskedInputProps,
    save,
    children,
    nativeProps,
    errorText,
    personalValue,
    validate,
    identifier,
    textBeforeButton,
    data,
    document,
    required,
    keyboardType,
  }: InputSingleTextNextButtonProps) => {
    const [value, setValue] = useState(
      currentData?.content || personalValue || data || '',
    )
    const [invalid, setInvalid] = useState(false)
    const content = children ? (
      children
    ) : inputMask || maskType ? (
      <MaskedInputBase
        placeholder={placeHolder}
        style={{ marginTop: 0, paddingTop: 0, textAlign: 'center' }}
        value={value}
        maskType={maskType}
        error={errorText}
        inputMask={inputMask}
        onChangeText={setValue}
        setInvalid={setInvalid}
        validateInput={
          validate
            ? (val) => {
                if (!val || (val && val.length === 9)) {
                  return ''
                } else {
                  return 'Invalid'
                }
              }
            : null
        }
        keyboardType={keyboardType}
        {...maskedInputProps}
      />
    ) : (
      <InputText
        placeholder={placeHolder}
        nativeProps={nativeProps}
        style={{
          marginTop: 0,
          paddingTop: 0,
          textAlign: 'center',
          backgroundColor: '#FFF',
        }}
        value={value}
        error={errorText}
        onChangeText={setValue}
        innerBorderStyle={{
          border: 'none',
          borderBottom: '1px solid rgb(155, 174, 188)',
          outline: 0,
          paddingBottom: 20,
        }}
        keyboardType={keyboardType}
      />
    )

    return (
      <>
        <ContainerCreditApplication style={{}}>
          {content}
          <HelperText type="error" visible={!!errorText}>
            {errorText || ' '}
          </HelperText>
        </ContainerCreditApplication>
        {textBeforeButton}
        <ButtonFlowNext
          containerStyle={{ marginTop: 40 }}
          disabled={required ? !value || invalid : invalid}
          onPress={() => onValue(value, identifier)}
          save={save}
          document={document}
        />
      </>
    )
  },
)
